import SbkGallery from '@/components/gallery/gallery'

SbkGallery.initialize();
